import NavDirective from './NavDirective';

export default angular.module('edge.platform.widgets.navigation', []).directive('gwPortalNav', NavDirective);


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/navigation/module.js
// module id = 1140
// module chunks = 0